import React, { useContext, useEffect, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { MODAL_FORM_DIALOG } from '../constants';
import { ModalContext } from '../../../contexts/ModalContext';
import DynamicForm from '../../DynamicForm';

const FormDialog = () => {
  const [successMessage, setSuccessMessage] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const modalContext = useContext(ModalContext);
  const modalOpen = modalContext.isModalOpen(MODAL_FORM_DIALOG);
  const modalProps = modalContext.openModalProps[MODAL_FORM_DIALOG];
  const modalActions = (
    <Button
      key="cancel"
      variant="contained"
      color="primary"
      onClick={() => modalContext.closeModal(MODAL_FORM_DIALOG)}
    >
      Close
    </Button>
  );

  useEffect(() => {
    setErrorMessage('');
    setSuccessMessage('');
  }, [modalOpen]);

  const onSubmit = (fields) => {
    setErrorMessage('');
    modalProps
      .onSubmit(fields)
      .then(() => {
        setSuccessMessage(modalProps.successMessage || 'Success!');
        if (modalProps.onSuccess) modalProps.onSuccess();
        modalContext.closeModal(MODAL_FORM_DIALOG);
      })
      .catch((e) => setErrorMessage(e.error_message || e.message || e.error));
  };

  if (modalOpen && modalProps) {
    return (
      <Dialog
        open={modalOpen}
        disableEnforceFocus={true}
        aria-labelledby="form-dialog-title"
        maxWidth={modalProps.width || 'sm'}
        fullWidth={true}
      >
        <DialogTitle id="form-dialog-title">{modalProps.title}</DialogTitle>
        <DialogContent>
          <DynamicForm
            fields={modalProps.fields}
            onSubmit={onSubmit}
            modalActions={modalActions}
            successMessage={successMessage}
            errorMessage={errorMessage}
          />
        </DialogContent>
      </Dialog>
    );
  } else {
    return null;
  }
};

export default FormDialog;
